import React, { lazy, useEffect, useRef, useState } from "react";
import { AccountDetails, PaymentOptions, StoreProps } from "./Payment.types";
import {
  useAppSelector,
  HOME_ROUTE,
  MY_TRANSACTION_ROUTE,
  useAppDispatch,
  showToast,
  ButtonVariable,
  AvailablePaymentGateways,
  demoUser,
  providerConfirmPaymentUrl,
  providerTransactionsUrl,
  AGPAY_ACTIONS,
  normalizeQueueMethod,
  normalizeDepositResponse,
} from "@hypexone/uicore";
import { isIOS } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import Paytring from "./DepositTabPanels/Paytring";
import { getBaseUrl } from "../../../api/api-services/environment-url/environment-url";
import PaymentClient from "@hypexone/uicore/lib/cjs/src/client/payment/payment_client";
import { AGPAY_API_CLIENT, errorHandler } from "../../../App.utils";
import CommonClient from "@hypexone/uicore/lib/cjs/src/client/reddog/common_client";
import Button from "../../components/shared/Button/Button";
import { normalizeInput } from "./commonutils";
import { BRAND_DOMAIN } from "../../../constants/Branding";

const Pgman = lazy(() => import("./DepositTabPanels/Pgman"));
const Payzln = lazy(() => import("./DepositTabPanels/Payzln"));
const PayzlnCrypto = lazy(() => import("./DepositTabPanels/PayzlnCrypto"));
const PayzlnCryptoSeamless = lazy(() => import("./DepositTabPanels/PayzlnCryptoSeamless"));

export type BonusDto = {
  id: number;
  name: string;
  description: string;
  bonusCategory: string;
};

const paymentOptionMap: Map<string, string> = new Map([
  ["UPI", "UPI"],
  ["GPAY", "UPI"],
  ["PHONEPE", "UPI"],
  ["PAYTM", "UPI"],
  ["BANK_TRANSFER", "IMPS"],
  ["CRYPTO_WALLET_TRANSFER", "CRYPTO_WALLET"],
]);

const Deposit: React.FC<StoreProps> = (props) => {
  const { setOpenDepositModal } = props;
  const [tabValue, setTabValue] = useState<number>(0);
  const [paymentOption, setPaymentOption] = useState<string>("UPI");
  const [accountDetails, setAccountDetails] = useState<AccountDetails[]>();
  const [selectedAccountId, setSelectedAccountId] = useState<string>();
  const [depositAmount, setDepositAmount] = useState<string>();
  const [depositNotes, setDepositNotes] = useState<string>();
  const [referenceId, setReferenceId] = useState<string>();
  const [depositImage, setDepositImage] = useState<string | ArrayBuffer>();
  const [loading, setLoading] = useState<boolean>(false);
  const [onlinePaymentOption, setOnlinePaymentOption] = useState<string>("UPI");
  const [mobileNumber, setMobileNumber] = useState<string>();
  const [paymentDetails, setPaymentDetails] = useState<PaymentOptions[]>();
  const [providerRefId, setProviderRefId] = useState<string>();
  const [providersList, setProvidersList] = useState([]);
  const [depositPaymentMethodsInfo, setDepositPaymentMethodsInfo] =
    useState<any>([]);
  const [minDepositAmount, setMinDepositAmount] = useState<number>(100);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [paymentOptionFilter, setPaymentOptionFilter] =
    useState<string>("IMPS");
  const [ocrDepositAmount, setOcrDepositAmount] = useState<string>();
  const [ocrReferenceId, setOcrReferenceId] = useState<string>();
  const [paymentGatewaysCount, setPaymentGatewaysCount] = useState<number>(0);
  const hiddenFileInput = useRef(null);
  const [uploadImage, setUploadImage] = useState(null);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [cryptoAmount, setCryptoAmount] = useState<string>("");
  const [exchangeRate, setExchangeRate] = useState<number | null>(null);
  const { domainConfig, whatsappDetails } = useAppSelector((state) => state.common);
  const navigate = useNavigate();
  const { langData } = useAppSelector((state) => state.cms);
  const dispatch = useAppDispatch();
  let indexCount = 0;

  const AGPAY_BASE_URL = getBaseUrl(
    import.meta.env.VITE_NODE_ENV,
    "REACT_APP_REST_AGPAY_URL"
  );

  const paymentClient = new PaymentClient(
    AGPAY_BASE_URL,
    sessionStorage.getItem("jwt_token"),
    errorHandler
  );

  const SVLS_BASE_URL = getBaseUrl(
    import.meta.env.VITE_NODE_ENV,
    "REACT_APP_REST_API_V2_URL"
  );

  const commonClient = new CommonClient(
    SVLS_BASE_URL,
    sessionStorage.getItem("jwt_token"),
    errorHandler
  );

  const [selectedPaymentMethod, setSelectedpaymentMethod] = useState("BANK_TRANSFER");

  //   const paymentImagesMap = {
  //     "BANK_TRANSFER" : BANK_TRANSFER,
  //     "UPI" : UPI_OPTIONS,
  //     "IMPS" : IMPS,
  //     "WALLET" : DIGITAL_WALLET
  //   }

  const successToast = (mess: string) => {
    dispatch(
      showToast({
        type: "success",
        message: mess,
      })
    );
  };

  const [showWhatsapp, setShowWhatsapp] = useState<boolean>(true);
  const [selectedBonus, setSelectedBonus] = useState<string>();
  const [bonusTypes, setBonusTypes] = useState<BonusDto[]>();

  // const getAdminWhatsAppNumber = () => {
  //     window.open(whatsappDetails, '_blank')
  // };

  const errorToast = (mess: string) => {
    dispatch(
      showToast({
        type: "error",
        message: mess || langData?.["general_err_txt"] || "Something went wrong",
      })
    );
  };

  const getSelectedPaymentOption = () => {
    const normalizedOnlineOption = normalizeQueueMethod(onlinePaymentOption);
    return (
      paymentDetails?.find(
        (i) => normalizeQueueMethod(i?.payment_method ?? i?.queue_source ?? "") ===
          normalizedOnlineOption
      ) ?? paymentDetails?.[0]
    );
  };


  const validateMinDeposit = (amount: string | number): boolean => {
    const numAmount = Number(amount);
    if (!numAmount || numAmount < 100) {
      errorToast(
        (langData?.['min_deposit_amount_txt']?.replace(/\s*\d+\s*$/, '') ??
          'Deposit Amount cannot be less than') +
          ' ' +
          100
      );
      return false;
    }
    return true;
  };

  const getImageDetails = async () => {
    setLoading(true);
    setDepositAmount("");
    setOcrDepositAmount("");
    setReferenceId("");
    setOcrReferenceId("");
    try {
      const response = await paymentClient.getTxnImageDetails(
        paymentOption,
        paymentOptionFilter,
        depositImage
      );

      if (response.status === 200 && response?.data) {
        const data = response.data;
        const amount = data.amount.trim();
        const utr = data.utr.trim();

        setDepositAmount(amount);
        setOcrDepositAmount(amount);
        setReferenceId(utr);
        setOcrReferenceId(utr);

        if (amount === "" || utr === "") {
          errorToast(langData?.['enter_details_manually_txt']);
        } else {
          successToast(langData?.['details_entered_success_txt']);
        }
      } else {
        errorToast(langData?.['general_err_txt']);
      }

      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const getUtr = async () => {
    setLoading(true);
    setReferenceId("");
    setOcrReferenceId("");
    try {
      const response = await paymentClient.getUtrDetails(
        paymentOption,
        paymentOptionFilter,
        depositImage
      );

      if (response.status === 200 && response?.data) {
        var utr = String(response.data).trim();
        setReferenceId(utr);
        setOcrReferenceId(utr);
        if (utr === "") {
          errorToast(langData?.['enter_details_manually_txt']);
        } else {
          successToast(langData?.['utr_entered_success_txt']);
        }
      } else {
        errorToast(langData?.['general_err_txt']);
      }

      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      depositImage !== undefined &&
      depositImage !== null &&
      depositImage !== ""
    ) {
      if (tabValue === 1) {
        getImageDetails();
      } else if (tabValue === 0) {
        getUtr();
      }
    }
  }, [depositImage]);

  const fetchPaymentMethod = async () => {
    try {
      const response = await paymentClient.getPaymentMethods(
        paymentOptionMap,
        paymentOption
      );

      if (response.status === 200) {
        let accountsArr = [];
        response.data.map((i) => {
          if (!i.disabled) accountsArr.push(i);
        });
        setAccountDetails(accountsArr);
        const initialSelectedAccount = accountsArr[0];
        setSelectedAccount(initialSelectedAccount);
        setSelectedAccountId(initialSelectedAccount?.id?.toString());
      } else {
      }
    } catch (error) { }
  };

  const getPaymentProviders = async () => {
    setLoading(true);
    try {
      const response = await paymentClient.getPaymentProviders();

      if (response.status === 200) {
        const depositMethods = response?.data?.depositMethods;
        setDepositPaymentMethodsInfo(depositMethods);
        setMinDepositAmount(response?.data?.minDeposit ?? 100);
        if (depositMethods) {
          const paymentMethodName = Object.keys(depositMethods)[0];
          setSelectedpaymentMethod(paymentMethodName);
          setPaymentOption(paymentMethodName);
          setProvidersList(
            depositMethods[paymentMethodName]
          );
          setPaymentDetails([]);
          setProviderRefId("");
          setOnlinePaymentOption(paymentMethodName);
        }
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    // setPaymentGatewaysCount(0);
    // getPaymentProviders();
    if (paymentOption === "NEFT") {
      // fetchPaymentMethod();
    }
    setDepositNotes("");
    setDepositAmount("");
    // setAccountDetails([]);
    // Keep beneficiary selection when switching Option 1/2 (payzln/pgman)
    // setOnlinePaymentOption('UPI');
    setPaymentOptionFilter("IMPS");
    // setBonusTypes([]);
  }, [tabValue]);

  const submitPayment = async (e) => {
    e.preventDefault();
    if (!depositImage) {
      errorToast(langData?.['upload_txn_img_txt']);
      return false;
    }
    setLoading(true);
    try {
      const payload: any = {
        amount: Number(depositAmount),
        notes: depositNotes,
        reference_id: referenceId,
        payment_method_id: selectedAccountId,
        payment_option:
          paymentOption === "NEFT"
            ? paymentOptionFilter
            : paymentOption === "UPI"
              ? "UPI"
              : paymentOptionMap.get(paymentOption) || "PAYTM_WALLET",
        amount_modified: ocrDepositAmount !== depositAmount,
        reference_id_modified: ocrReferenceId !== referenceId,
        bonus_policy_id: selectedBonus != '-' ? selectedBonus : null,
      };
      if (cryptoAmount && selectedAccount?.paymentMethodDetails?.cryptoCurrency) {
        payload.crypto_currency = selectedAccount.paymentMethodDetails.cryptoCurrency;
        payload.crypto_amount = Number(cryptoAmount);
      }
      let formData = new FormData();
      formData.append("paymentSlip", uploadImage);
      formData.append("request", JSON.stringify(payload));
      const response = await AGPAY_API_CLIENT.post(
        providerTransactionsUrl("pgman", AGPAY_ACTIONS.DEPOSIT),
        formData,
        {
          headers: {
            Authorization: sessionStorage.getItem("jwt_token"),
            "Content-Type": "multipart/form-data"
          },
        }
      );

      if (response.status === 200 || response.status === 204) {
        successToast(langData?.['txn_saved_success_txt']);
                window.location.href = MY_TRANSACTION_ROUTE;
        // setOpenDepositModal(false);
      } else {
        errorToast(response?.data?.message);
      }
      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const handleCapture = ({ target }) => {
    const file = target.files[0];
    if (file.size > 5 * 1024 * 1024) {
      errorToast('File upload error: The file size must be less than 5MB');
      target.value = '';
      setUploadImage(null);
      setDepositImage(null);
      return;
    }
    setUploadImage(file);
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (e) => {
      setDepositImage(e.target.result);
    };
  };
  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const getBonusTypes = async (amount: number, paymentMethod: string = onlinePaymentOption) => {
    try {
      const response = await commonClient.fetchBonusTypes(amount, paymentMethod == "UPI" ? "UPI_TRANSFER" : paymentMethod);
      if (response.status == 200) {
        const noBonus: BonusDto = {
          id: null,
          name: "-",
          description: "",
          bonusCategory: "",
        };
        setBonusTypes([noBonus, ...response.data]);
        if (response.data && response.data?.length > 0) {
          setSelectedBonus(response.data[0]?.id);
        }
      }
      return response.data;
    } catch (error) {
        const noBonus: BonusDto = {
          id: null,
          name: "-",
          description: "",
          bonusCategory: "",
        };
        setBonusTypes([noBonus]);
        setSelectedBonus(null);
    }
  };

  const openPaymentInNewTabAndRedirectToTransactions = (paymentUrl: string) => {
    successToast(langData?.['txn_saved_success_txt']);

    /**
     * This runs after an awaited API call, so the user gesture that started the
     * deposit has already expired. iOS Safari drops window.open() outside a live
     * gesture, which left the user sitting on my_transactions with no payment
     * page. Navigate the current tab instead - return_url brings them back.
     */
    if (isIOS) {
      window.location.href = paymentUrl;
      return;
    }

    const paymentWindow = window.open(paymentUrl, '_blank');
    if (!paymentWindow || paymentWindow.closed) {
      window.location.href = paymentUrl;
      return;
    }
    window.location.href = MY_TRANSACTION_ROUTE;

    /**
     * Router renders this page as <Deposit /> with no props, so this prop is
     * undefined and calling it throws. Kept last and optional so the redirect
     * above always runs - moving it earlier is what broke every platform in #408.
     */
    setOpenDepositModal?.(false);
  };

  const submitOnlineAmount = async (e, type = "abcmoney") => {
    e.preventDefault();
    if (
      type != "payzln" &&
      type != "paytring" &&
      type != "payzln1" &&
      type !== "payzln2" &&
      mobileNumber?.length != 10
    ) {
      errorToast(langData?.['invalid_mobile_no_txt']);
      return false;
    }
    if (Number(depositAmount) < 100) {
      errorToast(langData?.['min_deposit_amount_txt']);
      return false;
    }
    setLoading(true);

    try {
      const payload = {
        amount: Number(depositAmount),
        currency_type: "INR",
        mobile_number: mobileNumber ? mobileNumber : "9876543211",
        notes: depositNotes,
        payment_method:
          onlinePaymentOption === "UPI" ? "UPI_TRANSFER" : onlinePaymentOption,
        upi_intent: onlinePaymentOption === "UPI",
        upi_qr: onlinePaymentOption === "UPI",
        return_url: window.location.origin + "/my_transactions",
      };
      // if (type == "payzln") {
      //   getBonusTypes(Number(depositAmount));
      // }
      getBonusTypes(Number(depositAmount));
      const response = await paymentClient.submitDepositTransactions(
        type,
        payload
      );

      if (response.status === 200) {
        // Prefer queue_options from /pln/yuri (normalize maps uid/qrr/BT aliases)
        const depositData = normalizeDepositResponse(response.data);
        const paymentOptions = (depositData.payment_options ||
          []) as PaymentOptions[];
        if (paymentOptions.length > 0) {
          const depositPaymentOption = paymentOptions[0];

          if (depositPaymentOption?.sessionUrl) {
            const shouldOpenInNewTab = depositPaymentOption?.newTab === true;
            if (shouldOpenInNewTab) {
              openPaymentInNewTabAndRedirectToTransactions(
                depositPaymentOption.sessionUrl
              );
            } else {
              window.location.href = depositPaymentOption.sessionUrl;
            }
            return;
          } else if (depositPaymentOption?.paymentLink) {
            const shouldOpenInNewTab = depositPaymentOption?.newTab === true;
            if (shouldOpenInNewTab) {
              openPaymentInNewTabAndRedirectToTransactions(
                depositPaymentOption.paymentLink
              );
            } else {
              window.location.href = depositPaymentOption.paymentLink;
            }
            return;
          } else if (
            depositPaymentOption?.payment_method_details?.paymentLink
          ) {
            const shouldOpenInNewTab =
              depositPaymentOption?.payment_method_details?.newTab === true;
            if (shouldOpenInNewTab) {
              openPaymentInNewTabAndRedirectToTransactions(
                depositPaymentOption.payment_method_details.paymentLink
              );
            } else {
              window.location.href =
                depositPaymentOption.payment_method_details.paymentLink;
            }
            return;
          } else {
            setPaymentDetails(paymentOptions);
            if (depositData.provider_ref_id) {
              setProviderRefId(String(depositData.provider_ref_id));
            }
            setLoading(false);
            return;
          }
        }
        successToast(langData?.['txn_saved_success_txt']);
      }
      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const confirmPayment = async (e, selectedPaymentGateway = "abcmoney") => {
    e.preventDefault();
    const UPI_REGEX = /^[0-9]{12}$/;
    const RTGS_REGEX = /^[A-Z]{4}R[1-6][0-9]{2}[0-9]{8}[0-9]{8}$/;
    const NEFT_REGEX = /^[A-Z]{4}[NH][0-9]{2}[0-9]{3}[0-9]{6}$/;

    if (!depositImage) {
      errorToast('Please Upload Transaction Image');
      return false;
    }
    if (
      !(
        UPI_REGEX.test(referenceId) ||
        RTGS_REGEX.test(referenceId) ||
        NEFT_REGEX.test(referenceId)
      )
    ) {
      errorToast('Invalid UTR provided');
      return false;
    }
    const selectedPaymentOption = getSelectedPaymentOption();
    const selectedDetails =
      selectedPaymentOption?.payment_method_details ||
      selectedPaymentOption?.queue_source_details;
    if (!selectedDetails) {
      errorToast(langData?.["general_err_txt"] || "Payment details not found. Please try again.");
      return false;
    }

    setLoading(true);

    try {
      const payload = {
        gateway_provider_reference_id: providerRefId,
        utr: normalizeInput(referenceId),
        mobile_number: mobileNumber ? mobileNumber : "9876543211",
        bank_id: selectedDetails?.bank_id || selectedDetails?.bid,
        payment_option:
          onlinePaymentOption === "BANK_TRANSFER" ? "IMPS" : "UPI",
        reference_id_modified: ocrReferenceId !== referenceId,
        upi_intent: !!(
          selectedDetails?.uid ||
          selectedDetails?.upi_intent ||
          selectedDetails?.qrr ||
          selectedDetails?.upi_qr
        ),
        bonus_policy_id: selectedBonus != '-' ? selectedBonus : null,
      };
      let formData = new FormData();
      formData.append("paymentSlip", uploadImage);
      formData.append("request", JSON.stringify(payload));
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      const response = await AGPAY_API_CLIENT.post(
        providerConfirmPaymentUrl(selectedPaymentGateway),
        formData,
        {
          headers: {
            'Content-Type': `multipart/form-data`,
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200 || response.status === 204) {
        successToast(langData?.['txn_saved_success_txt']);
        window.location.href = MY_TRANSACTION_ROUTE;
        // setOpenDepositModal(false);
      }
      setLoading(false);
    } catch (error) {
      errorToast(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message
      );
      setLoading(false);
    }
  };

  let buttonVariables: ButtonVariable[] = [
    { label: '500', stake: 500 },
    { label: '1000', stake: 1000 },
    { label: '5000', stake: 5000 },
    { label: '10000', stake: 10000 },
    { label: '25000', stake: 25000 },
    { label: '50000', stake: 50000 },
    { label: '100000', stake: 100000 },
    { label: '500000', stake: 500000 },
    { label: '1000000', stake: 1000000 },
  ];

  const copyText = (text, toastMessage = langData?.['text_copied_txt']) => {
    navigator.clipboard.writeText(text);
    successToast(toastMessage);
  };

  useEffect(() => {
    if (paymentOption) {
      fetchPaymentMethod();
      setAccountDetails([]);
      setSelectedAccountId("");
      setDepositAmount("");
      setDepositImage("");
      setDepositNotes("");
      setReferenceId("");
      setCryptoAmount("");
      setExchangeRate(null);
      setShowDetailsForm(false);
      setBonusTypes([]);
    }
  }, [paymentOption]);

  useEffect(() => {
    setPaymentDetails([]);
    setDepositAmount("");
    setDepositNotes("");
    setReferenceId("");
    setMobileNumber("");
    setProviderRefId("");
  }, [onlinePaymentOption, tabValue]);

  const getAdminWhatsAppNumber = () => {
    window.open(whatsappDetails, '_blank')
  };

  const submitPaytring = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        payment_method: "UPI_TRANSFER",
        amount: Number(depositAmount),
        cname: sessionStorage.getItem("username"),
        phone: "9876543211",
        email: "johnny@email.com",
        callback_url: window.location.origin + "/transactions/my_transactions",
        bonus_policy_id: selectedBonus != '-' ? selectedBonus : null,
      };
      const response = await paymentClient.submitDepositTransactions(
        "paytring",
        payload
      );

      setLoading(false);
      if (response.status == 200 && response.data.url) {
        window.location.href = atob(response.data.url);
        successToast(langData?.['txn_saved_success_txt']);
      } else {
        errorToast(langData?.['general_err_txt']);
      }
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const renderPaymentForm = (
    paymentGateway: AvailablePaymentGateways,
    index: number,
    tabValue: number
  ) => {
    switch (paymentGateway) {
      case AvailablePaymentGateways.PGMAN:
        return (
          <Pgman
            index={index}
            tabValue={tabValue}
            paymentOption={paymentOption}
            setPaymentOption={setPaymentOption}
            accountDetails={accountDetails}
            selectedAccountId={selectedAccountId}
            setSelectedAccountId={setSelectedAccountId}
            setSelectedAccount={setSelectedAccount}
            selectedAccount={selectedAccount}
            copyText={copyText}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            submitPayment={submitPayment}
            depositAmount={depositAmount}
            depositNotes={depositNotes}
            referenceId={referenceId}
            setDepositAmount={setDepositAmount}
            setDepositNotes={setDepositNotes}
            setReferenceId={setReferenceId}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            loading={loading}
            ref={hiddenFileInput}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            onlinePaymentOption={onlinePaymentOption}
            bonusTypes={bonusTypes}
            setBonusTypes={setBonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            getBonusTypes={getBonusTypes}
            showDetailsForm={showDetailsForm}
            setShowDetailsForm={setShowDetailsForm}
            cryptoAmount={cryptoAmount}
            setCryptoAmount={setCryptoAmount}
            exchangeRate={exchangeRate}
            setExchangeRate={setExchangeRate}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            showWhatsapp={showWhatsapp}
            minDepositAmount={minDepositAmount}
            errorToast={errorToast}
          />
        );
      case AvailablePaymentGateways.PAYZLN:
        return (
          <Payzln
            index={index}
            providersList={providersList}
            onlinePaymentOption={onlinePaymentOption}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            submitOnlineAmount={submitOnlineAmount}
            paymentDetails={paymentDetails}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            loading={loading}
            providerRefId={providerRefId}
            confirmPayment={confirmPayment}
            copyText={copyText}
            referenceId={referenceId}
            setReferenceId={setReferenceId}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            setShowWhatsapp={setShowWhatsapp}
            showWhatsapp={showWhatsapp}
            bonusTypes={bonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            pgProvider="payzln"
          />
        );
      case AvailablePaymentGateways.PAYZLN1:
        return (
          <Payzln
            index={index}
            providersList={providersList}
            onlinePaymentOption={onlinePaymentOption}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            submitOnlineAmount={submitOnlineAmount}
            paymentDetails={paymentDetails}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            loading={loading}
            providerRefId={providerRefId}
            confirmPayment={confirmPayment}
            copyText={copyText}
            referenceId={referenceId}
            setReferenceId={setReferenceId}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            setShowWhatsapp={setShowWhatsapp}
            showWhatsapp={showWhatsapp}
            bonusTypes={bonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            pgProvider="payzln1"
          />
        );
      case AvailablePaymentGateways.PAYZLN2:
        return (
          <Payzln
            index={index}
            providersList={providersList}
            onlinePaymentOption={onlinePaymentOption}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            submitOnlineAmount={submitOnlineAmount}
            paymentDetails={paymentDetails}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            loading={loading}
            providerRefId={providerRefId}
            confirmPayment={confirmPayment}
            copyText={copyText}
            referenceId={referenceId}
            setReferenceId={setReferenceId}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            setShowWhatsapp={setShowWhatsapp}
            showWhatsapp={showWhatsapp}
            bonusTypes={bonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            pgProvider="payzln2"
          />
        );
      case AvailablePaymentGateways.PAYZLNCRYPTO:
        return (
          <PayzlnCrypto
            setOpenDepositModal={setOpenDepositModal}
            setLoading={setLoading}
            index={index}
            providersList={providersList}
            onlinePaymentOption={onlinePaymentOption}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            loading={loading}
            copyText={copyText}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            setShowWhatsapp={setShowWhatsapp}
            showWhatsapp={showWhatsapp}
            bonusTypes={bonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            getBonusTypes={getBonusTypes}
            depositImage={depositImage}
            handleClick={handleClick}
            handleCapture={handleCapture}
            uploadImage={uploadImage}
            minDepositAmount={minDepositAmount}
          />
        );
      case AvailablePaymentGateways.PAYZLNCRYPTOSEAMLESS:
        return (
          <PayzlnCryptoSeamless
            index={index}
            providersList={providersList}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            copyText={copyText}
            ref={hiddenFileInput}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            showWhatsapp={showWhatsapp}
          />
        );
      case AvailablePaymentGateways.PAYTRING:
        return (
          <Paytring
            index={index}
            providersList={providersList}
            tabValue={tabValue}
            submitPaytring={submitPaytring}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            loading={loading}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            bonusTypes={bonusTypes}
            setBonusTypes={setBonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            getBonusTypes={getBonusTypes}
          />
        );
      default:
        return null;
    }
  };

  // const getPaymentIcon = (method) => {
  //     return method === 'GPAY'
  //         ? gpay
  //         : method === 'PHONEPE'
  //             ? phonePe
  //             : method === 'BANK_TRANSFER'
  //                 ? bank
  //                 : method === 'PAYTM'
  //                     ? paytm
  //                     : null;
  // };

  useEffect(() => {
    if (depositPaymentMethodsInfo) {
      setProvidersList(depositPaymentMethodsInfo[selectedPaymentMethod] || []);
    }
  }, [depositPaymentMethodsInfo]);

  useEffect(() => {
    getPaymentProviders();
  }, []);

  useEffect(() => {
    if (!domainConfig.payments) {
      navigate(HOME_ROUTE, { replace: true });
    }
  }, []);

  return (
    <section className="flex flex-col items-start pb-44 bg-white rounded border border-solid border-black border-opacity-10 max-md:pb-24 p-2 md:p-0">
      <header className="self-stretch px-4 py-1.5 text-2xl max-md:text-[18px] max-md:py-1 text-white rounded bg-blue-950 max-md:pr-5 max-md:max-w-full">
        {langData?.['deposit_amount']}
      </header>

      <div className=" p-3 max-md:w-full max-md:py-2 max-md:px-0 ">
        <div 
          className="flex items-center text-base leading-none text-black w-full md:w-[400px] cursor-pointer overflow-x-auto scroll-smooth max-md:overflow-x-scroll payment-methods-scroll"
        >
          {depositPaymentMethodsInfo &&
            Object.keys(depositPaymentMethodsInfo).map(
              (paymentMethodName, index) => {
                return (
                  <div
                    key={index}
                    className={`gap-2.5 self-stretch px-4 py-2 flex-shrink-0 ${selectedPaymentMethod === paymentMethodName
                        ? "bg-blue-950 text-white"
                        : "bg-stone-300 border-r border-blue-950"
                      }`}
                    onClick={() => {
                      setBonusTypes([]);
                      setShowDetailsForm(false);
                      setSelectedpaymentMethod(paymentMethodName);
                      setPaymentOption(paymentMethodName);
                      setProvidersList(
                        depositPaymentMethodsInfo[paymentMethodName]
                      );
                      setPaymentDetails([]);
                      setProviderRefId("");
                      setOnlinePaymentOption(paymentMethodName);
                    }}
                  >
                    <div className="text-center text-sm font-medium whitespace-nowrap">
                      {paymentMethodName === "BANK_TRANSFER"
                        ? langData?.['bank']
                        : paymentMethodName === "CRYPTO_WALLET_TRANSFER"
                          ? langData?.['crypto']
                          : langData?.[paymentMethodName.toLowerCase()]}
                    </div>
                  </div>
                );
              }
            )}

          {
            whatsappDetails && (
              <Button
                onClick={getAdminWhatsAppNumber}
                className="flex justify-center items-center self-stretch animate-blink_deposit text-white text-sm font-medium whitespace-nowrap border border-black px-4 py-2 flex-shrink-0"
              >
                {langData?.['whatsapp_deposit']}
              </Button>
            )
          }
        </div>
        {
          demoUser() && (
            <div className="text-xs animate-pulse text-yellow mb-4">
              {
                langData?.["demo_deposits_msg"]
              }
            </div>
          )
        }
        <div className="text-xs animate-pulse text-red-500">
          Disclaimer: For faster and more reliable payments, please use the bank transfer option.
        </div>
        <div>
          {providersList?.length > 1 && (
            <div className="flex space-x-4 my-4">
              {providersList.map((paymentGateway, index) => (
                <Button
                  key={index}
                  onClick={() => setTabValue(index)}
                  className={`py-2 px-4 rounded-lg ${tabValue === index
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-black"
                    }`}
                >
                  {langData?.['option']} {index + 1}
                </Button>
              ))}
            </div>
          )}

          <div>
            {providersList?.length > 0 &&
              providersList.map((paymentGateway, index) =>
                renderPaymentForm(paymentGateway, index, tabValue)
              )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Deposit;